import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { baseUrlRisk, baseUrl, recommendationUrl } from '../../constants/constants';
import { getRiskAPIResponseData, getApiResponseData, getPostResponseAPIData } from '../../services/apiservices';
import { pushAccountWiseHeatMap, pushSelectedAccount, pushClickEvent } from '../../slices/ApplicationDrillHeatMapSlice';
import { pushApplicationTrendData } from '../../slices/ApplicationWiseTrendSlice';
import { pushTableData, pushRiskTableData } from '../../slices/recommendationTableSlice';
import DashBoard from '../Dashboard/Dashboard';
import { pushApplicationRiskData } from '../../slices/ApplicationDrillChartSlice';
import { PageLayout } from '../MainPageStyle';
import ApplicationwiseBreadCrumb from '../Breadcrumbs/AccountwiseBreadCrumb';
import { pushOverAllRiskScoreCardData } from '../../slices/OverAllRiskScoreCardSlice';
import Grid from '@material-ui/core/Grid';
import { PageTitle } from '../Dashboard/DashboardStyle';
import StatusCard from '../StatusCard/StatusCard';
import { pushShowSpinner, pushHideSpinner } from '../../slices/SpinnerSlice';
import { pushCheckboxData, pushClearFilterArray, pushSelectedChipArray, deleteChipArrayAddCriteria, pushChipArrayAddCriteria } from '../../slices/RiskFilterSlice';
import { pushOverallHeatMap, pushSelectedApplication } from '../../slices/HeatMapSlice';
import { pushExportRecommandationApi, pushExportRiskApi } from '../../slices/ApiStateSlice';
export default function TreemapApplication(props) {
  let appIdParam = props.match.params.appId;
  const dispatch = useDispatch();
  const [flag, setFlag] = useState(false);
  const [selected, setSelected] = useState('');
  const [updatedpage, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [watch, setWatch] = React.useState(0);
  const [riskTablePage, setRiskTablePage] = React.useState(0);
  const [riskTableRowsPerPage, setRiskTableRowsRowsPerPage] = React.useState(10);
  const [recomandationLoading, setRecomenationLoading] = React.useState(false);
  const [riskLoading, setRiskLoading] = React.useState(false);
  const [overallTrendLoading, setOverallTrendLoading] = React.useState(false);
  const [order, setOrder] = React.useState('DSC');
  const [orderBy, setOrderBy] = React.useState('accountRiskScore');
  const [riskColumOrder, setRiskColumOrder] = React.useState('DSC');
  const [riskColumOderBy, setRiskColumOderBy] = React.useState('users');
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const recoReqBody = useSelector(state => state.riskFilterSlice.recoReqBody);

  const handlesetLoading = recomendationSpinnerStatus => {
    setRecomenationLoading(recomendationSpinnerStatus);
  };

  const handleriskLoading = riskSpinnerLoading => {
    setRiskLoading(riskSpinnerLoading);
  };

  const handleOverallTrendLoading = overalTrendSpinnerLoading => {
    setOverallTrendLoading(overalTrendSpinnerLoading);
  };

  const handleRequestSort = property => {
    const isDsc = orderBy === property && order === 'DSC';
    setOrder(isDsc ? 'ASC' : 'DSC');
    setOrderBy(property);
  };

  const handleSetriskTableSortString = property => {
    const isDsc = riskColumOderBy === property && riskColumOrder === 'DSC';
    setRiskColumOrder(isDsc ? 'ASC' : 'DSC');
    setRiskColumOderBy(property);
  };

  const updatedWatchData = useSelector(state => state.recommendationTable.WatchResponseData);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const nextTableData = useSelector(state => state.recommendationTable.ApplicationResponse);
  const apiResponseData = useSelector(state => state.recommendationTable.ApplicationResponse);
  const accountWiseApiResponseData = useSelector(state => state.recommendationTable.applicationDrillHeatmap);
  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  useEffect(() => {
    dispatch(pushShowSpinner(true));
    let paginationStringOrigin = 'origins-wise';
    let riskUrl = baseUrlRisk + paginationStringOrigin;
    dispatch(getRiskAPIResponseData(riskUrl, 'riskResponse'));
    let paginationQueryString = '';

    if (watch) {
      paginationQueryString = `?filter=appId=${appIdParam},underWatch=${watch},recoType=Any&limit=${rowsPerPage}&offset=${updatedpage}&sortBy=${orderBy}:${order}&view=recommendation`;
      let exportUrl = baseUrl + paginationQueryString;
      dispatch(pushExportRecommandationApi(exportUrl));
    } else {
      paginationQueryString = `?filter=appId=${appIdParam},recoType=Any&limit=${rowsPerPage}&offset=${updatedpage}&sortBy=${orderBy}:${order}&view=recommendation`;
      let exportUrl = baseUrl + paginationQueryString;
      dispatch(pushExportRecommandationApi(exportUrl));
    }

    let url = baseUrl + paginationQueryString;

    if (!applyEvent) {
      dispatch(getApiResponseData(url, 'ApplicationResponse'));
    } else {
      dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
    }
  }, [rowsPerPage, updatedpage, watch, updatedWatchData, order, orderBy]);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const dataDoughnut = useSelector(state => state.applicationDrillChart.dataDoughnut);
  const dataLine = useSelector(state => state.applicationWiseTrend.dataLine);
  const heatMap = useSelector(state => state.applicationDrillHeatMap.dataSet);
  useEffect(() => {
    dispatch(pushShowSpinner(true));
    let paginationStringOrigin = `accounts-wise?filter=appId=${appIdParam}&limit=${riskTableRowsPerPage}&offset=${riskTablePage}&sortBy=${riskColumOderBy}:${riskColumOrder}`;
    let riskUrl = baseUrlRisk + paginationStringOrigin;
    dispatch(pushExportRiskApi(riskUrl));
    dispatch(getRiskAPIResponseData(riskUrl, 'applicationDrillHeatmap'));
  }, [riskColumOderBy, riskColumOrder, appIdParam, riskTablePage, riskTableRowsPerPage]);
  let applicationRiskTableData = [];
  let appId = '';
  let accountUuid = '';

  if (accountWiseApiResponseData && accountWiseApiResponseData.data) {
    applicationRiskTableData = accountWiseApiResponseData.data.responseList;
  }

  let applicationTableData = [];

  if (apiResponseData && apiResponseData.data) {
    applicationTableData = apiResponseData.data.responseList;
  }

  const environmentWiseTrendApiResponseData = useSelector(state => state.recommendationTable.applicationDrillTrend);
  let paginationStringTrend = 'origin-trend?filter=appId=';
  let trendUrl = baseUrlRisk + paginationStringTrend + appIdParam;
  useEffect(() => {
    dispatch(getRiskAPIResponseData(trendUrl, 'applicationDrillTrend'));
    dispatch(pushClickEvent(true));
  }, []);
  useEffect(() => {
    if (apiResponseData && apiResponseData.data && apiResponseData.data.responseList) {
      let displayData = apiResponseData.data.responseList;
      dispatch(pushTableData(displayData));
      dispatch(pushHideSpinner(false));
    }

    if (accountWiseApiResponseData && accountWiseApiResponseData.data && accountWiseApiResponseData.data.responseList) {
      let accountWiseData = accountWiseApiResponseData.data.responseList;
      let accountAccordion = accountWiseApiResponseData.data.responseList.filter(item => item.envName);

      if (accountWiseData.length > 0) {
        dispatch(pushSelectedApplication(accountWiseData[0].appName));
      }

      dispatch(pushAccountWiseHeatMap(accountWiseData));
      dispatch(pushRiskTableData(accountWiseData));
      dispatch(pushCheckboxData(accountAccordion));
      dispatch(pushHideSpinner(false));
    }

    if (environmentWiseTrendApiResponseData && environmentWiseTrendApiResponseData.data) {
      let environmentWiseTrendData = environmentWiseTrendApiResponseData.data;
      dispatch(pushApplicationTrendData(environmentWiseTrendData));
      setOverallTrendLoading(true);
    }

    if (riskApiResponseData && riskApiResponseData.data && riskApiResponseData.data.responseList) {
      let overAllRisk = riskApiResponseData.data.responseList;
      let overAllRiskObj = {};
      let riskObject = {};

      if (overAllRisk.length > 0) {
        const riskDataForApp = overAllRisk.filter(data => data.appId === appIdParam);

        if (riskDataForApp) {
          riskObject['riskScore'] = riskDataForApp[0].originRiskScore;
          riskObject['riskCategory'] = riskDataForApp[0].originRiskCategory;
        }

        overAllRiskObj['riskScore'] = overAllRisk[0].overallRiskScore;
        overAllRiskObj['riskCategory'] = overAllRisk[0].overallRiskCategory;
      }

      dispatch(pushApplicationRiskData(riskObject));
      dispatch(pushOverAllRiskScoreCardData(overAllRiskObj));
    }
  }, [apiResponseData, accountWiseApiResponseData, environmentWiseTrendApiResponseData, riskApiResponseData]);
  const statuCardData = useSelector(state => state.OverAllRiskScoreCardData.statusData);
  let clearAllDataOrigin = [];

  if (riskApiResponseData && riskApiResponseData.data) {
    clearAllDataOrigin = riskApiResponseData.data.responseList;
  }

  useEffect(() => {
    dispatch(pushClearFilterArray([]));
    dispatch(deleteChipArrayAddCriteria([]));
    dispatch(pushSelectedChipArray([]));
    dispatch(pushOverallHeatMap(clearAllDataOrigin));
    dispatch(pushChipArrayAddCriteria([]));
  }, [clickEvent]);

  const clickHandler = (event, chartContext, config) => {
    let selectedValue = config.globals.categoryLabels[event.target.attributes['j'].value];
    handleTableRowClick(selectedValue[1]);
  };

  const handleTableRowClick = selectedValue => {
    setSelected(selectedValue);
    setFlag(true);
  };

  useEffect(() => {
    if (flag) {
      if (accountWiseApiResponseData && accountWiseApiResponseData.data && selected) {
        let riskScoreObj = accountWiseApiResponseData.data.responseList.filter(item => item.envName === selected);

        if (riskScoreObj && riskScoreObj.length) {
          appId = riskScoreObj[0].appId;
          accountUuid = riskScoreObj[0].accountUuid;
        }
      }

      dispatch(pushSelectedAccount(selected));
      props.history.push(`/analytics/environments/${appId}/${accountUuid}`);
    }
  }, [accountWiseApiResponseData, flag, selected]);
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(ApplicationwiseBreadCrumb, null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(PageTitle, null, selectedApplication)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(StatusCard, {
    statuCardData: statuCardData
  }))), /*#__PURE__*/React.createElement(DashBoard, {
    history: props.history,
    dataDoughnut: dataDoughnut,
    dataLine: dataLine,
    heatMap: heatMap,
    clickHandler: clickHandler,
    dashboardLabel: selectedApplication,
    riskTableData: applicationRiskTableData,
    tableData: applicationTableData,
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    handleSetriskTableSortString: handleSetriskTableSortString,
    watch: watch,
    setWatch: setWatch,
    setRiskTablePage: setRiskTablePage,
    setRiskTableRowsRowsPerPage: setRiskTableRowsRowsPerPage,
    riskTableRowsPerPage: riskTableRowsPerPage,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    riskLoading: riskLoading,
    handleriskLoading: handleriskLoading,
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading,
    risknextTableData: accountWiseApiResponseData,
    order: order,
    orderBy: orderBy,
    riskColumOrder: riskColumOrder,
    riskColumOderBy: riskColumOderBy,
    applicationLabel: "Environments",
    riskLabel: "Risk Score",
    handleTableRowClick: handleTableRowClick,
    isTreemapApplication: true,
    pageType: "environment"
  }));
}